import React, { useEffect } from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { createStructuredSelector } from 'reselect';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

import {
  LISTINGLAYOUT_COMPONENT,
  FILTER_SECTION,
  SMARTLIST_SECTION,
  FILTEREEDLIST_SECTION,
} from './locators';
import Grid from '../../../components/molecules/Grid';
import useStyles from './style';
import FilteredList from '../FilteredList';
import { filteredData } from './selectors';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { getComponentName } from '../../../utils/getPageComponentInfo';
import { pageContentType } from '../../../utils/getContentType';
import { ATTRIBUTE_TYPE, TAG_TEXT } from '../../../../constants/index';
import { getFilterdInfoData } from '../Filters/redux/actions';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { getCurrentLanguage } from '../../../utils/getCurrentLanguage';
import { canUseDOM } from '../../../utils/canUseDOM';
import clsx from 'clsx';

const ListingSubLayout = props => {
  let solrPayloadToFetchFilter = {};
  const language = getCurrentLanguage(props);
  const classes = useStyles();
  const contentType = pageContentType(props).toLowerCase();
  const isFilteredDataAvailable = Boolean(get(props, 'filteredData.data.results'));
  const isAttributeListingPage = () => {
    return (contentType === ATTRIBUTE_TYPE)
  }

  const payloadForAttributeListingCall = (tagValue) => {
    solrPayloadToFetchFilter.contentType = contentType;
    solrPayloadToFetchFilter.language = language;
    solrPayloadToFetchFilter.facetFields = [];
    //For attribute listing page initial card limits are driven by sitecore, 
    solrPayloadToFetchFilter.limit = Number(getDictionaryText('attributePageLoadCount'));
    solrPayloadToFetchFilter.offset = 0;
    solrPayloadToFetchFilter.filters = [{ key: TAG_TEXT, value: tagValue }];

    return solrPayloadToFetchFilter;
  };

  useEffect(() => {
    let tagValue;
    if (isAttributeListingPage()) {
      if (canUseDOM) {
        const params = new URLSearchParams(window.location.search)
        tagValue = params && params.get(TAG_TEXT);
      }
      const payload = payloadForAttributeListingCall(tagValue);
      props.getFilterdInfoData({
        apiUrl: `${props.appConfig.SOLR_FILTERS_DATA}`,
        payload: payload,
      });
    }
  }, []);
  return (
    <Grid
      item
      className={clsx(classes.listingLayoutWrappeer, 'listingPageWrapper')}
      data-locator={LISTINGLAYOUT_COMPONENT}
    >
      <Grid
        item
        className={classes.filterSection}
        data-locator={FILTER_SECTION}
      >
        <Placeholder name="vad-left-col" rendering={props.rendering} appConfig={props.appConfig} />
      </Grid>
      {!isFilteredDataAvailable && !isAttributeListingPage() && ( //Attribute listing page doesn't contain any smartlist
        <Grid
          item
          className={classes.smartList}
          data-locator={SMARTLIST_SECTION}
        >
          <Placeholder name="vad-right-col" rendering={props.rendering} appConfig={props.appConfig} />
        </Grid>
      )}
      {isFilteredDataAvailable && (
        <Grid
          item
          className={classes.filterdList}
          data-locator={FILTEREEDLIST_SECTION}
          aria-live="polite"
        >
          <FilteredList componentName={getComponentName(props)} appConfig={props.appConfig} isAttributeListingPage={isAttributeListingPage()} />
        </Grid>
      )}
    </Grid>
  );
};

export const mapDispatchToProps = dispatch => {
  return {
    getFilterdInfoData: params => dispatch(getFilterdInfoData(params)),
  };
};

export const mapStateToProps = createStructuredSelector({
  filteredData: filteredData,
});

export default withErrorBoundary(
  withSitecoreContext()(
    withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(ListingSubLayout))
  )
);